import { Tag, Typography } from "antd";
import dayjs from "dayjs";
import { TagJoStatus } from "../../../../components/badge-and-tag/ERP";
import DocLink from "../../../../components/table/DocLink";

const num = (v) => Number(v || 0);
export const fmtQty = (v) =>
  num(v).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 4 });
const fmtInt = (v) => num(v).toLocaleString(undefined, { maximumFractionDigits: 0 });

/* สีประจำประเภทสินค้า ให้ดูออกเร็วว่าเป็นวัตถุดิบชนิดไหน */
export const TYPE_COLOR = {
  "Raw Material": "green",
  Ingredients: "lime",
  Packing: "blue",
  Packaging: "geekblue",
  "Work Instruction": "purple",
  "Finished Goods": "orange",
  "Finish Goods": "orange",
};

/* คอลัมน์บนหน้าจอ — ลำดับนี้ถูกส่งไปใช้ตอน export excel ด้วย */
export const usageColumns = ({ openJo } = {}) => [
  { title: "ลำดับ", dataIndex: "seq", key: "seq", width: 65, align: "center", fixed: "left" },
  {
    title: "Job Order",
    dataIndex: "jocode",
    key: "jocode",
    width: 130,
    fixed: "left",
    /* กดรหัสเพื่อเปิดหน้า Job Order */
    render: (v, rec) =>
      openJo ? (
        <DocLink value={v} record={rec} onClick={() => openJo(v)} title="เปิดดู Job Order" />
      ) : (
        <Typography.Text strong>{v}</Typography.Text>
      ),
  },
  {
    title: "วันที่ JO",
    dataIndex: "jodate",
    key: "jodate",
    width: 110,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  { title: "ลูกค้า", dataIndex: "cusname", key: "cusname", width: 200 },
  { title: "Brand", dataIndex: "brand", key: "brand", width: 130 },
  {
    title: "สินค้าที่ผลิต",
    dataIndex: "pg_code",
    key: "pg_code",
    width: 130,
    render: (v, r) => v || r.detail_code || "-",
  },
  { title: "ชื่อสินค้าที่ผลิต", dataIndex: "pg_name", key: "pg_name", width: 220 },
  {
    title: "จำนวนกล่อง",
    dataIndex: "carton",
    key: "carton",
    width: 110,
    align: "right",
    render: (v) => (v == null ? "-" : fmtInt(v)),
  },
  {
    title: "จำนวนที่ใช้",
    dataIndex: "qty",
    key: "qty",
    width: 130,
    align: "right",
    render: (v) => <Typography.Text strong>{fmtQty(v)}</Typography.Text>,
  },
  { title: "หน่วย", dataIndex: "unit", key: "unit", width: 90, align: "center" },
  {
    title: "สถานะ JO",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 140,
    align: "center",
    /* ใช้ตัวเดียวกับหน้า Job Order สีจะได้ตรงกันทั้งระบบ */
    render: (v) => <TagJoStatus result={v} />,
  },
];

/* คอลัมน์ที่ส่งไป export (ไม่เอาคอลัมน์ที่เป็น element) */
export const exportColumns = () =>
  usageColumns().map((c) => ({ key: c.key, title: c.title }));
